export default [
    'SPDataObjectsProvider',
    function TagConfig(SPDataObjectsProvider) {
        SPDataObjectsProvider.defineDataObject('Tag', function Tag(tagData) {
            this.id = tagData.id;
            this.name = tagData.name;
        });
    }
];
